import React, { useEffect, useState } from "react";
import ImageWithBasePath from "../../core/img/imagewithbasebath";
import { Link } from "react-router-dom";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Profile = () => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    userName: "",
    password: "",
    profilePic: null,
    // Bank Details
    account_holder: "",
    account_number: "",
    bank_name: "",
    bank_code: "",
    branch_name: "",
    branch_code: "",
  });
  const [imagePreview, setImagePreview] = useState(null);
  const [userId, setUserId] = useState(null);

  useEffect(() => {
    const storedUserData = localStorage.getItem("user");
    if (storedUserData) {
      const userData = JSON.parse(storedUserData);
      const id = userData?.data?._id;
      setUserId(id);
      if (id) {
        fetchUserData(id);
      }
    }
  }, []);

  const fetchUserData = async (id) => {
    try {
      // Using the new endpoint that returns bank details
      const response = await axios.get(`http://localhost:8000/api/user/new/${id}`);
      if (response.data && response.data.data) {
        const user = response.data.data;
        setFormData({
            firstName: user.name || "", // Assuming name is full name or just one field
            lastName: "", // backend seems to have only 'name'
            email: user.email || "",
            phone: user.phone || "",
            userName: user.user_name || "",
            password: "", // Don't pre-fill password
            profilePic: null,
            account_holder: user.account_holder || "",
            account_number: user.account_number || "",
            bank_name: user.bank_name || "",
            bank_code: user.bank_code || "",
            branch_name: user.branch_name || "",
            branch_code: user.branch_code || "",
        });
        if (user.profile_picture) {
            setImagePreview(user.profile_picture);
        }
      }
    } catch (error) {
      console.error("Error fetching user data:", error);
      toast.error("Failed to load user data");
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFormData((prev) => ({
        ...prev,
        profilePic: file,
      }));
      setImagePreview(URL.createObjectURL(file));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!userId) {
        toast.error("User not identified");
        return;
    }

    const data = new FormData();
    data.append("name", formData.firstName); // backend uses 'name'
    data.append("email", formData.email);
    data.append("phone", formData.phone);
    // data.append("user_name", formData.userName); // backend might not update user_name
    if (formData.password) {
        data.append("password", formData.password);
    }
    if (formData.profilePic) {
        data.append("profilePicture", formData.profilePic);
    }
    
    // Bank Details
    data.append("account_holder", formData.account_holder);
    data.append("account_number", formData.account_number);
    data.append("bank_name", formData.bank_name);
    data.append("bank_code", formData.bank_code);
    data.append("branch_name", formData.branch_name);
    data.append("branch_code", formData.branch_code);

    try {
      const response = await axios.put(`http://localhost:8000/api/user/update/${userId}`, data, {
        headers: {
            "Content-Type": "multipart/form-data",
        },
      });
      if (response.status === 200) {
        toast.success("Profile updated successfully");
        // Update local storage if name/image changed? 
        // For now, let's just reload data or leave it.
        fetchUserData(userId);
      }
    } catch (error) {
      console.error("Error updating profile:", error);
      toast.error(error.response?.data?.message || "Failed to update profile");
    }
  };

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header">
          <div className="page-title">
            <h4>Profile</h4>
            <h6>User Profile</h6>
          </div>
        </div>
        
        <ToastContainer />

        <div className="card">
          <div className="card-body">
            <form onSubmit={handleSubmit}>
                <div className="profile-set">
                <div className="profile-head"></div>
                <div className="profile-top">
                    <div className="profile-content">
                    <div className="profile-contentimg">
                        <ImageWithBasePath
                        src={imagePreview || "assets/img/customer/customer5.jpg"}
                        alt="img"
                        id="blah"
                        />
                        <div className="profileupload">
                        <input type="file" id="imgInp" onChange={handleFileChange} accept="image/*" />
                        <Link to="#">
                            <ImageWithBasePath src="assets/img/icons/edit-set.svg" alt="img" />
                        </Link>
                        </div>
                    </div>
                    <div className="profile-contentname">
                        <h2>{formData.firstName || "User"}</h2>
                        <h4>Updates Your Photo and Personal Details.</h4>
                    </div>
                    </div>
                </div>
                </div>
                
                <div className="row">
                <div className="col-lg-6 col-sm-12">
                    <div className="input-blocks">
                    <label className="form-label">Full Name</label>
                    <input
                        type="text"
                        className="form-control"
                        name="firstName"
                        value={formData.firstName}
                        onChange={handleChange}
                        placeholder="Enter full name"
                    />
                    </div>
                </div>
                {/* 
                <div className="col-lg-6 col-sm-12">
                    <div className="input-blocks">
                    <label className="form-label">Last Name</label>
                    <input
                        type="text"
                        className="form-control"
                        name="lastName"
                        value={formData.lastName}
                        onChange={handleChange}
                        placeholder="Enter last name"
                    />
                    </div>
                </div>
                */}
                <div className="col-lg-6 col-sm-12">
                    <div className="input-blocks">
                    <label>Email</label>
                    <input
                        type="email"
                        className="form-control"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        placeholder="Enter email"
                    />
                    </div>
                </div>
                <div className="col-lg-6 col-sm-12">
                    <div className="input-blocks">
                    <label className="form-label">Phone</label>
                    <input 
                        type="text" 
                        name="phone"
                        value={formData.phone}
                        onChange={handleChange}
                        placeholder="Enter phone number"
                    />
                    </div>
                </div>
                <div className="col-lg-6 col-sm-12">
                    <div className="input-blocks">
                    <label className="form-label">User Name</label>
                    <input
                        type="text"
                        className="form-control"
                        name="userName"
                        value={formData.userName}
                        readOnly
                        placeholder="Username"
                        style={{ backgroundColor: "#e9ecef" }}
                    />
                    </div>
                </div>
                <div className="col-lg-6 col-sm-12">
                    <div className="input-blocks">
                    <label className="form-label">Password</label>
                    <div className="pass-group">
                        <input
                        type="password"
                        className="pass-input form-control"
                        name="password"
                        value={formData.password}
                        onChange={handleChange}
                        placeholder="Leave blank to keep current password"
                        />
                        <span className="fas toggle-password fa-eye-slash" />
                    </div>
                    </div>
                </div>
                </div>

                {/* Bank Details Section */}
                <div className="row mt-4">
                    <div className="col-12">
                        <h5 className="mb-3">Bank Details</h5>
                    </div>
                    <div className="col-lg-6 col-sm-12">
                        <div className="input-blocks">
                            <label className="form-label">Account Holder Name</label>
                            <input
                                type="text"
                                className="form-control"
                                name="account_holder"
                                value={formData.account_holder}
                                onChange={handleChange}
                                placeholder="Enter account holder name"
                            />
                        </div>
                    </div>
                    <div className="col-lg-6 col-sm-12">
                        <div className="input-blocks">
                            <label className="form-label">Account Number</label>
                            <input
                                type="text"
                                className="form-control"
                                name="account_number"
                                value={formData.account_number}
                                onChange={handleChange}
                                placeholder="Enter account number"
                            />
                        </div>
                    </div>
                    <div className="col-lg-6 col-sm-12">
                        <div className="input-blocks">
                            <label className="form-label">Bank Name</label>
                            <input
                                type="text"
                                className="form-control"
                                name="bank_name"
                                value={formData.bank_name}
                                onChange={handleChange}
                                placeholder="Enter bank name"
                            />
                        </div>
                    </div>
                    <div className="col-lg-6 col-sm-12">
                        <div className="input-blocks">
                            <label className="form-label">Bank Code</label>
                            <input
                                type="text"
                                className="form-control"
                                name="bank_code"
                                value={formData.bank_code}
                                onChange={handleChange}
                                placeholder="Enter bank code"
                            />
                        </div>
                    </div>
                    <div className="col-lg-6 col-sm-12">
                        <div className="input-blocks">
                            <label className="form-label">Branch Name</label>
                            <input
                                type="text"
                                className="form-control"
                                name="branch_name"
                                value={formData.branch_name}
                                onChange={handleChange}
                                placeholder="Enter branch name"
                            />
                        </div>
                    </div>
                    <div className="col-lg-6 col-sm-12">
                        <div className="input-blocks">
                            <label className="form-label">Branch Code</label>
                            <input
                                type="text"
                                className="form-control"
                                name="branch_code"
                                value={formData.branch_code}
                                onChange={handleChange}
                                placeholder="Enter branch code"
                            />
                        </div>
                    </div>
                </div>

                <div className="col-12 mt-3">
                    <button type="submit" className="btn btn-submit me-2">
                        Submit
                    </button>
                    <Link to="#" className="btn btn-cancel">
                        Cancel
                    </Link>
                </div>
            </form>
          </div>
        </div>
        {/* /product list */}
      </div>
    </div>
  );
};

export default Profile;
